import { SelectOption } from '../../types/input';
import { LeaveType } from '../../types/leave';
import { UserStatus } from '../../types/users';

export const employeeOnboardingTabs = [
  'Personal Details',
  'Identity Documents',
  'Educational Documents',
  'Work Experience',
  'Review & Submit',
];

export const genderOptions: SelectOption[] = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
  { value: 'prefer-not-to-say', label: 'Prefer not to say' },
];

export const relationshipOptions: SelectOption[] = [
  { value: 'Spouse', label: 'Spouse' },
  { value: 'Parent', label: 'Parent' },
  { value: 'Sibling', label: 'Sibling' },
  { value: 'Child', label: 'Child' },
  { value: 'Relative', label: 'Relative' },
  { value: 'Friend', label: 'Friend' },
  { value: 'Colleague', label: 'Colleague' },
  { value: 'Other', label: 'Other' },
];

export const MODULES: Array<{ id: string; label: string }> = [
  {
    id: 'HRMS',
    label: 'HRM',
  },
  {
    id: 'Project Management',
    label: 'PMO',
  },
  {
    id: 'CRM',
    label: 'CRM',
  },
  // {
  //   id: 'Finance',
  //   label: 'Finance',
  // },
  // {
  //   id: 'Reports',
  //   label: 'Reports',
  // },
];

export const handBookTableHeaders = ['Document Name', 'Description', 'Actions'];
export const tabOptions = [
  'Personal Info',
  'Identity Documents',
  'Educational Documents',
  'Work Experience',
  'Job Details',
  'Leave Balance',
];
export const employeeProfileTabOptions = [
  'Personal Info',
  'Identity Documents',
  'Job Details',
  'Educational Documents',
  'Work Experience',
];

// Department options
export const departmentOptions = [
  { value: 'sales', label: 'Sales Department' },
  { value: 'engineering', label: 'Engineering' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'hr', label: 'Human Resources' },
  { value: 'finance', label: 'Finance' },
];

// Role options
export const roleOptions = [
  { value: 'manager', label: 'Manager' },
  { value: 'developer', label: 'Developer' },
  { value: 'designer', label: 'Designer' },
  { value: 'analyst', label: 'Analyst' },
  { value: 'specialist', label: 'Specialist' },
];

export const maritalStatusOptions = [
  { value: 'Single', label: 'Single' },
  { value: 'Married', label: 'Married' },
  { value: 'Divorced', label: 'Divorced' },
  { value: 'Widowed', label: 'Widowed' },
];

export const leaveTypeOptions = [
  { label: 'Annual Leave', value: 'annual' },
  { label: 'Sick Leave', value: 'sick' },
  { label: 'Casual Leave', value: 'casual' },
  { label: 'Maternity Leave', value: 'maternity' },
  { label: 'Paternity Leave', value: 'paternity' },
  { label: 'Unpaid Leave', value: 'unpaid' },
  { label: 'Compensatory Leave', value: 'compensatory' },
];

export const primaryIdOptions: SelectOption[] = [
  { value: 'passport', label: 'Passport' },
  { value: 'national-id', label: 'National ID' },
  { value: 'drivers-license', label: "Driver's License" },
  { value: 'residence-permit', label: 'Residence Permit' },
  { value: 'birth-certificate', label: 'Birth Certificate' },
  { value: 'social-security', label: 'Social Security Card' },
  { value: 'other', label: 'Other' },
];

export const monthNames: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// Monday-first, matching the react-calendar-based date pickers used
// elsewhere in HRMS (Apply Leave, Job Details Joining Date) — this custom
// calendar previously started on Sunday, the one inconsistent week-start
// convention in the app.
export const dayNames: string[] = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
];

export const leaveTypes: Record<string, LeaveType> = {
  working: { color: 'bg-[#10B981]', label: 'Present', abbr: 'PR' },
  sick: { color: 'bg-[#EF4444]', label: 'Absent', abbr: 'AB' },
  planned: { color: 'bg-[#A78BFA]', label: 'Leave', abbr: 'LV' },
  holiday: { color: 'bg-[#F59E0B]', label: 'Holiday', abbr: 'HD' },
  weekend: { color: 'bg-[#818CF8]', label: 'Weekly Off', abbr: 'WO' },
};

// export const ROLE_OPTIONS: UserRole[] = [
//   'None',
//   'Employee',
//   'Manager',
//   'Admin',
// ];

export const STATUS_OPTIONS: UserStatus[] = [
  'Active',
  'Suspended',
  'Invite Sent',
];

export const notificationsTabs = [
  { id: 'all', label: 'All' },
  { id: 'unread', label: 'Unread' },
  { id: 'mentions', label: 'Mentions' },
  { id: 'assigned', label: 'Assigned' },
];
